import { useStack } from '@/react/common/stacks/queries/useStack';

import { useGitHelmChartInfo } from '../helmChartSourceQueries/useGitHelmChartInfo';

export function useGitChartInfoFromStackID(stackID?: number) {
  const stackQuery = useStack(stackID);
  const credentialID =
    stackQuery.data?.GitConfig?.Authentication?.GitCredentialID;
  const gitChartInfoQuery = useGitHelmChartInfo({
    repository: stackQuery.data?.GitConfig?.URL || '',
    chartPath: stackQuery.data?.HelmChartPath || '',
    reference: stackQuery.data?.GitConfig?.ReferenceName,
    username: stackQuery.data?.GitConfig?.Authentication?.Username,
    password: stackQuery.data?.GitConfig?.Authentication?.Password,
    authorizationType:
      stackQuery.data?.GitConfig?.Authentication?.AuthorizationType,
    gitCredentialID: credentialID,
    stackID,
    tlsSkipVerify: stackQuery.data?.GitConfig?.TLSSkipVerify,
    command: 'chart',
  });
  return gitChartInfoQuery;
}
